import styled from "styled-components";

export const OverlayText = styled.div`
  position: absolute;
  left: 50%;
  right: 0px;
  text-align: left;
  opacity: 0.8;
  top: 20%;
  color: rgb(64, 64, 65);
  text-shadow: none;
  padding: 40px;
`;

export const OverlayTexts = styled.div`
  position: absolute;
  left: 50%;
  right: 0px;
  text-align: left;
  opacity: 0.8;
  top: 20%;
  color: rgb(64, 64, 65);
  text-shadow: none;
  padding: 40px 15px;
`;

export const CarouselTitle = styled.h3`
  font-family: "Montserrat", sans-serif;
  text-align: left;
  font-size: 48px;
  font-weight: 700;
  text-transform: uppercase;
  color: #005a2c;
`;

export const CarouselSubTitle = styled.span`
  font-family: 'Montserrat', sans-serif;
  display: inline-block;
  font-weight: 500;
  font-size: 16px;
  text-align: left;
  font-style: italic;
  margin: 15px 0;
  color: #3c763d;
  max-width: 60%;
`;
